import Vue from 'vue'
import VueJWT from 'vuejs-jwt'
import axios from 'axios'
import AppToast from '../components/frontend/appToast'

const appToast = new AppToast()

Vue.use(VueJWT)

export default class AuthService {
    isLoggedIn() {
        if (localStorage.getItem('token')) {
            var decodedToken = Vue.$jwt.decode(localStorage.getItem('token'));
            if (decodedToken) {
                if (decodedToken.exp < new Date().getTime() / 1000) {
                    appToast.danger("Session expired. Please re-login your account");
                    return false;
                } else {
                    return true; // allow access
                }
            }
        } else {
            return false;
        }
    }

    hasGuestEmployeeAccess() {
        if (localStorage.getItem('geToken')) {
            var decodedToken = Vue.$jwt.decode(localStorage.getItem('geToken'));
            if (decodedToken) {
                if (decodedToken.exp < new Date().getTime() / 1000) {
                    alert("Guest employee access expired. Please make another request");
                    return false;
                } else {
                    axios.get(`api/guestemployeetimesheets/check-hash?hash=${decodedToken.nameid}`).then(response=>{
                        return response.data;
                    })
                }
            }
        } else {
            return false;
        }
    }

    hasGuestEmployeeAccessDateFrom(){
        if(!this.isGuestEmployeeTokenIsExpired()){
            var decodedToken = Vue.$jwt.decode(localStorage.getItem('geToken'))
            return decodedToken.dateFrom
        }
    }

    hasGuestEmployeeAccessDateTo(){
        if(!this.isGuestEmployeeTokenIsExpired()){
            var decodedToken = Vue.$jwt.decode(localStorage.getItem('geToken'))
            return decodedToken.dateTo
        }
    }

    isGuestEmployeeTokenIsExpired(){
         if (localStorage.getItem('geToken')) {
            var decodedToken = Vue.$jwt.decode(localStorage.getItem('geToken'));
            if (decodedToken) {
                if (decodedToken.exp < new Date().getTime() / 1000) {
                    alert("Guest employee access expired. Please make another request");
                    return false;
                }else{
                    return true
                }
            }
        }
    }

    getUserRole() {
        if (localStorage.getItem('token')) {
            var decodedToken = Vue.$jwt.decode(localStorage.getItem('token'))
            if (decodedToken) {
                return decodedToken.role
            }
        }
    }

    getLoggedInUserId() {
        if (localStorage.getItem('token')) {
            var decodedToken = Vue.$jwt.decode(localStorage.getItem('token'))
            if (decodedToken) {
                return decodedToken.nameid
            }
        }
    }

    hasAdminPriv() {
        // check if the object is an array
        const userRole = this.getUserRole()

        if (Object.prototype.toString.call(userRole) === "[object Array]") {
            var hasAdmin = userRole.includes('Admin');
            if (hasAdmin) {
                return true
            } else {
                return false;
            }
        } else {
            if (userRole === "Admin") {
                return true;
            } else {
                return false;
            }
        }
    }
}